export default {
      id: "full-screen-usage",
      viewBox: "0 0 15.95 15.95",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#full-screen",
      toString: function () {
        return this.url;
      }
    }